import { title, mlAuto, mrAuto } from "assets/jss/material-kit-pro-react.js";

const featuresStyle = {
  featuresSection: {
    padding: "80px 0px"
  },
  textCenter: {
    textAlign: "center"
  },
  title,
  mlAuto,
  mrAuto
};

export default featuresStyle;
